import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-code-login',
  standalone: true,
  templateUrl: './code-login.component.html',
  styleUrls: ['./code-login.component.scss'],
})
export class CodeLoginComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private spinner: SpinnerService,
  ) {}

  ngOnInit(): void {
    this.spinner.show();

    const code = this.route.snapshot.paramMap.get('code');

    if (!code) {
      alert('Código de verificación inválido');
      this.spinner.hide();
      return;
    }

    this.authService.loginWithCode(code).subscribe({
      next: () => {
        this.spinner.hide();
        this.router.navigate(['/add-card']);
      },
      error: (err) => {
        this.spinner.hide();
        alert('Error al autenticar. Por favor intenta nuevamente.');
        console.error(err);
      },
    });
  }
}
